import useFeatureFlags from 'common/hooks/useFeatureFlags';
import useUser from 'common/hooks/useUser';

export const useIsWoltSpecialsInListingManagerEnabled = () => {
  const { isEmployee, user } = useUser();

  const { data: featureFlags, isInitialLoading } = useFeatureFlags(
    ['enable_wolt_specials_listing_manager'],
    {
      user_id: user?.id || '',
    },
    { enabled: isEmployee },
  );

  if (!isEmployee) {
    return {
      isWoltSpecialsInListingManagerEnabled: false,
      isWoltSpecialsInListingManagerEnabledLoading: false,
    };
  }

  return {
    isWoltSpecialsInListingManagerEnabled: featureFlags?.enable_wolt_specials_listing_manager === 'on',
    isWoltSpecialsInListingManagerEnabledLoading: isInitialLoading,
  };
};
